module.exports = __webpack_public_path__ + "static/media/international-cases.4b76c306.png";